(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breed-lp"]) return;
  try {
    
  (function () {
    if (customElements.get('lp-page')) return;
    customElements.define('lp-page', class extends HTMLElement {
      connectedCallback() {
        if (this._lpReady) return;
        this._lpReady = true;
        var self = this;
        try { this.data = JSON.parse(this.querySelector('[data-lp-data]').textContent); } catch (e) { this.data = []; }
        if (!this.data.length) return;
        this.track = this.querySelector('[data-track]');
        this.thumbsEl = this.querySelector('[data-thumbs]');
        this.count = this.querySelector('[data-count]');
        this.chips = Array.from(this.querySelectorAll('[data-breed]'));
        // Breed-specific benefits (swap in when a breed is picked)
        this.breedUsps = {"dachshund": [["moon", "Sleep through, no 3am Doxie wake-ups"], ["paw", "Skirting boards safe from little teeth"], ["heart", "A Doxie who's calm when you leave"], ["home", "Toilet training for a stubborn Doxie"], ["growth", "Dachshunds don't just \"grow out of it\""], ["check", "Trusted by 5,000+ owners"]], "labrador": [["paw", "Tame the 70lb \"wrecking ball\""], ["heart", "From \"Velcro Lab\" to happy alone"], ["leash", "No more tug of war on walks"], ["vet", "Food obsession, finally calmer"], ["growth", "Labs don't just \"grow out of it\""], ["check", "Trusted by 5,000+ owners"]], "chihuahua": [["bell", "From \"tiny terror\" to polite pup"], ["heart", "\"Velcro Chi\"? Calm when you go out"], ["leash", "Gentle walks, kind to a tiny neck"], ["home", "Potty training, even on rainy days"], ["growth", "Small dog, big habits: start now"], ["check", "Trusted by 5,000+ owners"]], "golden-retriever": [["paw", "Gentle mouths, no more \"landshark\""], ["heart", "\"Velcro Golden\"? Calm when you go"], ["leash", "No more being towed to every dog"], ["books", "Better listening, no trainer bills"], ["growth", "Goldens don't just \"grow out of it\""], ["check", "Trusted by 5,000+ owners"]], "labradoodle": [["heart", "From \"Velcro Doodle\" to settled solo"], ["comb", "No more guilty Doodle shave-downs"], ["home", "From counter surfer to good manners"], ["leash", "Less bounce on walks, more calm"], ["growth", "Doodle zoomies won't fade on their own"], ["check", "Trusted by 5,000+ owners"]], "cavapoo": [["heart", "\"Velcro Cavapoo\"? Settled solo"], ["comb", "Fewer mats, no guilty shave-downs"], ["home", "No more sneaky snacks off the table"], ["leash", "Calm walks for a small, excitable pup"], ["growth", "Puppy habits stick unless you start"], ["check", "Trusted by 5,000+ owners"]], "cockapoo": [["heart", "From \"Velcro Cockapoo\" to calm alone"], ["comb", "A coat you can brush, not shave off"], ["home", "No more paws up on the kitchen table"], ["leash", "Spaniel energy, calm on the lead"], ["growth", "Cockapoo bounce won't fade by itself"], ["check", "Trusted by 5,000+ owners"]], "cocker-spaniel": [["heart", "Relaxed around toys and food"], ["comb", "Cocker ears kept clean and healthy"], ["leash", "Nose up, lead loose"], ["bell", "A calmer, quieter Cocker"], ["growth", "Cocker habits don't fade with age"], ["check", "Trusted by 5,000+ owners"]], "french-bulldog": [["vet", "Safer on warm days"], ["comb", "Clean folds, comfy skin"], ["books", "Frenchie stubbornness, won over"], ["home", "Reliable toilet habits, indoors and out"], ["growth", "Frenchies don't just \"grow out of it\""], ["check", "Trusted by 5,000+ owners"]], "german-shepherd": [["leash", "Walks with a strong dog, made easy"], ["bell", "A guard dog who listens"], ["heart", "Confident, not on edge"], ["vet", "Strong joints, gentle exercise"], ["growth", "Shepherds don't just \"grow out of it\""], ["check", "Trusted by 5,000+ owners"]], "springer-spaniel": [["paw", "Recall you can rely on"], ["comb", "Ears, coat and grass seed care"], ["leash", "Walks that aren't a hunting trip"], ["home", "A calmer Springer at home"], ["growth", "Springer energy won't fade alone"], ["check", "Trusted by 5,000+ owners"]], "staffordshire-bull-terrier": [["paw", "Calm around other dogs"], ["heart", "From \"Velcro Staffy\" to settled alone"], ["leash", "Calm walks with a strong Staffy"], ["comb", "Comfier, healthier skin"], ["growth", "Staffies don't just \"grow out of it\""], ["check", "Trusted by 5,000+ owners"]]};
        this.uspsEl = this.querySelector('[data-usps]');
        this.uspsDefault = this.uspsEl ? this.uspsEl.innerHTML : '';
        this.slide = 0;
        var params = new URLSearchParams(window.location.search);

        // Breed (preselect from ?breed=)
        var want = (params.get('breed') || '').toLowerCase();
        // Match ?breed= loosely (chihuahua, chihuahua-guide, staffy, golden...). No match = treat as no breed.
        var start = -1, alias = { staffy: 'staffordshire-bull-terrier', staffie: 'staffordshire-bull-terrier', frenchie: 'french-bulldog', golden: 'golden-retriever', springer: 'springer-spaniel', cocker: 'cocker-spaniel', shepherd: 'german-shepherd', gsd: 'german-shepherd', lab: 'labrador', doodle: 'labradoodle', doxie: 'dachshund', chi: 'chihuahua' };
        if (want) {
          want = alias[want] || want;
          this.data.forEach(function (b, i) { if (start < 0 && (b.slug === want || b.handle === want)) start = i; });
          this.data.forEach(function (b, i) { if (start < 0 && b.slug && (want.indexOf(b.slug) === 0 || b.slug.indexOf(want) === 0)) start = i; });
          this.data.forEach(function (b, i) { if (start < 0 && b.handle && b.slug && b.handle.indexOf(b.slug) !== -1 && want.indexOf(b.slug) !== -1) start = i; });
          if (start < 0) want = '';
        }
        if (start < 0) start = 0;
        this.chips.forEach(function (c) { c.addEventListener('click', function () { self.select(Number(c.dataset.breed)); self.compact(true); }); });
        // No breed in the link + starting images set: show the general images until a breed is picked
        // Came from a breed link: show a compact "Your breed: X · Change breed" row instead of all 12
        var ch = this.querySelector('[data-change]');
        if (ch) ch.addEventListener('click', function () { self.compact(false); });
        if (want) this.compact(true);
        if (!want && this.track.hasAttribute('data-start')) this.generic();
        else this.select(start, true);

        // Gallery
        this.track.addEventListener('scroll', function () {
          if (self.ticking) return;
          self.ticking = true;
          requestAnimationFrame(function () {
            self.ticking = false;
            var i = Math.round(self.track.scrollLeft / (self.track.clientWidth || 1));
            if (i !== self.slide) self.mark(i);
          });
        }, { passive: true });
        this.track.addEventListener('click', function () {
          var n = self.track.children.length;
          if (n < 2) return;
          var i = (self.slide + 1) % n;
          self.sx(self.track, i * self.track.clientWidth, true);
          self.mark(i);
        });
        var galGo = function (d) {
          var n = self.track.children.length; if (n < 2) return;
          var i = (self.slide + d + n) % n;
          self.sx(self.track, i * self.track.clientWidth, true);
          self.mark(i);
        };
        var gp = this.querySelector('[data-gal-prev]'), gn = this.querySelector('[data-gal-next]');
        if (gp) gp.addEventListener('click', function (e) { e.stopPropagation(); galGo(-1); });
        if (gn) gn.addEventListener('click', function (e) { e.stopPropagation(); galGo(1); });
        this.thumbsEl.addEventListener('click', function (e) {
          var t = e.target.closest('[data-thumb]');
          if (!t) return;
          var i = Number(t.dataset.thumb);
          self.sx(self.track, i * self.track.clientWidth, true);
          self.mark(i);
        });

        // Basket
        var atc = function (btn) {
          if (self.current == null) { self.pickFirst(); return; }
          var b = self.data[self.current];
          if (!b || !b.available || self._adding) return;
          self._adding = true;
          btn.disabled = true;
          var oldTxt = btn.textContent;
          btn.textContent = 'Adding to basket…';
          self.querySelector('[data-error]').hidden = true;
          // Digital guides: always SET the quantity to 1 (adds it if missing), so a second tap or another CTA never makes it 2
          var upd = {}; upd[b.variant] = 1;
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
            .then(function (r) { if (!r.ok) throw new Error('add'); self._adding = false; self.afterAdd(btn, oldTxt); })
            .catch(function () { self._adding = false; btn.disabled = false; btn.textContent = oldTxt; self.querySelector('[data-error]').hidden = false; });
        };
        var mainBtn = this.querySelector('[data-atc]');
        mainBtn.addEventListener('click', function () { atc(mainBtn); });
        var stickyBtn = this.querySelector('[data-atc-sticky]');
        stickyBtn.addEventListener('click', function () { atc(stickyBtn); });
        this.querySelectorAll('[data-atc-more]').forEach(function (bt) { bt.addEventListener('click', function () { atc(bt); }); });

        this.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', function () { self.closeCart(); }); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.closeCart(); });
        var cartLink = this.querySelector('[data-cart-open]');
        if (cartLink && this.dataset.after === 'drawer') cartLink.addEventListener('click', function (e) { e.preventDefault(); self.openCart(); });
        this.querySelector('[data-cart-items]').addEventListener('click', function (e) {
          var rm = e.target.closest('[data-rm]');
          if (!rm) return;
          rm.disabled = true;
          fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: rm.dataset.rm, quantity: 0 }) })
            .then(function (r) { return r.json(); }).then(function (c) { self.renderCart(c); });
        });
        var top = this.querySelector('[data-scrolltop]');
        if (top) top.addEventListener('click', function (e) { e.preventDefault(); self.pickFirst(); });

        // Tap a card to move to the next one (these looked tappable but did nothing)
        var advance = function (box, itemSel) {
          if (!box) return;
          box.addEventListener('click', function (e) {
            var item = e.target.closest(itemSel);
            if (!item || !item.nextElementSibling) { self.sx(box, 0, true); return; }
            self.sx(box, item.nextElementSibling.offsetLeft - (box.firstElementChild ? box.firstElementChild.offsetLeft : 0), true);
          });
        };
        advance(this.querySelector('[data-inside]'), 'li');
        // Stars line: jump to the reviews
        var rating = this.querySelector('.lp-rating'), revSec = this.querySelector('[data-reviews]');
        if (rating && revSec) {
          rating.style.cursor = 'pointer';
          rating.addEventListener('click', function () { try { revSec.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { revSec.scrollIntoView(); } });
        }
        // Before a breed is picked, tapping a benefit or the collection line takes you to the breed picker
        if (this.uspsEl) this.uspsEl.addEventListener('click', function () { if (self.current == null) self.pickFirst(); });

        // Reviews: one at a time, box fits the review on show, arrows + dots
        var rv = this.querySelector('[data-reviews]'), dots = this.querySelector('[data-dots]');
        if (rv && rv.children.length) {
          var rvIdx = 0;
          var fit = function () { var c = rv.children[rvIdx]; if (c) rv.style.height = c.offsetHeight + 'px'; };
          var mark = function (i) {
            rvIdx = i;
            if (dots) Array.from(dots.children).forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
            fit();
          };
          var go = function (i) {
            var n = rv.children.length;
            i = (i + n) % n;
            self.sx(rv, rv.children[i].offsetLeft - rv.children[0].offsetLeft, true);
            mark(i);
          };
          var rvTick = false;
          rv.addEventListener('scroll', function () {
            if (rvTick) return; rvTick = true;
            requestAnimationFrame(function () {
              rvTick = false;
              var i = Math.round(rv.scrollLeft / (rv.clientWidth || 1));
              if (i !== rvIdx && rv.children[i]) mark(i);
            });
          }, { passive: true });
          var pv = this.querySelector('[data-rv-prev]'), nx = this.querySelector('[data-rv-next]');
          if (pv) pv.addEventListener('click', function () { go(rvIdx - 1); });
          if (nx) nx.addEventListener('click', function () { go(rvIdx + 1); });
          if (dots) Array.from(dots.children).forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
          fit();
          window.addEventListener('resize', fit);
          window.addEventListener('load', fit);
          if ('ResizeObserver' in window) { var ro = new ResizeObserver(fit); Array.from(rv.children).forEach(function (c) { ro.observe(c); }); }
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
        }

        // Sticky bar: always on screen
      }

      afterAdd(btn, oldTxt) {
        var mode = this.dataset.after;
        if (mode === 'checkout') { window.location.href = '/checkout'; return; }
        if (mode === 'cart') { window.location.href = this.dataset.cartUrl || '/cart'; return; }
        btn.disabled = false; btn.textContent = oldTxt;
        this.openCart();
      }

      money(n, cur) {
        try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur || 'GBP' }).format(n / 100); } catch (e) { return '£' + (n / 100).toFixed(2); }
      }

      openCart() {
        var self = this, box = this.querySelector('[data-cart]');
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          self.renderCart(c);
          box.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          var x = box.querySelector('.lp-cart__x'); if (x) x.focus();
        }).catch(function () { window.location.href = self.dataset.cartUrl || '/cart'; });
      }

      closeCart() {
        this.querySelector('[data-cart]').hidden = true;
        document.documentElement.style.overflow = '';
      }

      renderCart(c) {
        var self = this, list = this.querySelector('[data-cart-items]');
        list.innerHTML = c.items.length ? c.items.map(function (it) {
          var was = it.original_line_price > it.final_line_price ? '<s>' + self.money(it.original_line_price, c.currency) + '</s>' : '';
          return '<div class="lp-cart__item">' + (it.image ? '<img src="' + self.esc(it.image) + '" alt="" width="64" height="64">' : '') + '<div><b>' + self.esc(it.product_title) + (it.quantity > 1 ? ' × ' + it.quantity : '') + '</b><p>' + was + '<span class="now">' + self.money(it.final_line_price, c.currency) + '</span></p><button type="button" class="lp-cart__rm" data-rm="' + self.esc(it.key) + '">Remove</button></div></div>';
        }).join('') : '<p class="lp-cart__empty">Your basket is empty.</p>';
        this.querySelector('[data-cart-total]').textContent = this.money(c.total_price, c.currency);
        this.querySelector('.lp-cart__foot .lp-btn').hidden = !c.items.length;
      }

      setUsps(b, still) {
        var el = this.uspsEl, tag = this.querySelector('[data-usps-for]');
        if (!el) return;
        var list = null;
        if (b) {
          var map = this.breedUsps, keys = Object.keys(map);
          var cands = [b.slug, b.handle, String(b.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-'), String(b.short || '').toLowerCase()];
          for (var c = 0; c < cands.length && !list; c++) {
            var s = cands[c] || '';
            if (!s) continue;
            for (var k = 0; k < keys.length; k++) {
              var key = keys[k];
              if (s === key || s.indexOf(key) !== -1 || (key === 'golden-retriever' && s.indexOf('golden') !== -1) || (key === 'french-bulldog' && /french|frenchie/.test(s)) || (key === 'staffordshire-bull-terrier' && s.indexOf('staff') !== -1) || (key === 'springer-spaniel' && s.indexOf('springer') !== -1) || (key === 'german-shepherd' && s.indexOf('shepherd') !== -1) || (key === 'cocker-spaniel' && s.indexOf('cocker') !== -1 && s.indexOf('cockapoo') === -1)) { list = map[key]; break; }
            }
          }
        }
        var icons = this.querySelector('[data-usp-icons]');
        if (list) {
          var html = list.map(function (u) {
            var ic = icons && icons.content ? (icons.content.querySelector('[data-ic="' + u[0] + '"]') || icons.content.querySelector('[data-ic="check"]')) : null;
            return '<li><span class="lp-usp__icon">' + (ic ? ic.innerHTML : '') + '</span><span class="lp-usp__text">' + u[1] + '</span></li>';
          }).join('');
          el.innerHTML = html;
          var nm = b.short || b.name;
          if (tag) tag.textContent = 'Written for ' + (/y$/.test(nm) ? nm.slice(0, -1) + 'ies' : /s$/.test(nm) ? nm : nm + 's');
          if (tag) tag.hidden = false;
        } else {
          el.innerHTML = this.uspsDefault;
          if (tag) tag.hidden = true;
        }
        el.classList.remove('is-swap'); if (still) return; void el.offsetWidth; el.classList.add('is-swap');
      }

      // Breed picked: collapse the grid to "Your breed: X · Change breed"
      compact(on) {
        var picker = this.querySelector('.lp-breeds'), pk = this.querySelector('[data-picked]');
        if (!picker) return;
        picker.classList.toggle('is-compact', !!on);
        if (pk) pk.hidden = !on;
      }

      ctaPrice(b) {
        var t = this.querySelector('[data-cta-total]'), p = this.querySelector('[data-cta-price]');
        if (t) t.textContent = b && b.hasSaving ? b.total : '';
        if (p && b) p.textContent = b.price;
      }

      pickFirst() {
        var f = this.querySelector('.lp-breeds');
        try { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { f.scrollIntoView(); }
        f.classList.remove('is-nudge'); void f.offsetWidth; f.classList.add('is-nudge');
      }

      generic() {
        var b = this.data[0];
        this.current = null;
        this.mark(0);
        this.querySelectorAll('[data-rows-block]').forEach(function (blk) { blk.hidden = true; });
        this.setUsps(null, true);
        this.querySelector('[data-price]').textContent = b.price;
        this.querySelector('[data-total]').textContent = b.hasSaving ? b.total : '';
        this.querySelector('[data-badge]').textContent = b.hasSaving ? 'SAVE ' + b.percent + '%' : '';
        this.querySelector('[data-atc-label]').textContent = 'Choose your breed to continue';
        this.querySelectorAll('[data-atc-more]').forEach(function (bt) { bt.textContent = 'Choose your breed'; });
        this.ctaPrice(b);
        this.querySelector('[data-sticky-name]').textContent = 'All 7 guides';
        this.querySelector('[data-sticky-price]').textContent = b.price;
        var stT = this.querySelector('[data-sticky-total]'); if (stT) stT.textContent = b.hasSaving ? b.total : '';
        this.querySelector('[data-atc-sticky]').textContent = 'Choose your breed';
        this.querySelector('[data-inside-h]').textContent = "What's included for your dog";
        this.genericInside();
      }

      genericInside() {
        var g = [['The Puppy Guide', 'Settling in, toilet training, socialising and the chewing months.', 'Main'], ['The Adult Guide', 'Training, diet, grooming and health, for life.', 'Main'], ['The Pulling Fix', 'A 21-day plan for calm, loose-lead walks.', 'Bonus'], ['The Barking Fix', 'A 21-day plan for a quieter home.', 'Bonus'], ['The Toilet Habits Fix', 'A simple plan for fewer accidents.', 'Bonus'], ["2 guides for your breed's known problems", 'Like coat care, confidence or joints, depending on your breed.', 'Bonus']];
        this.querySelector('[data-inside]').innerHTML = g.map(function (x) { return '<li><span class="lp-inside__ph"><svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z"/><path d="M4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5"/></svg></span><b>' + x[0] + '</b><em class="' + (x[2] === 'Main' ? 'is-main' : '') + '">' + x[2] + '</em></li>'; }).join('');
        this.querySelector('[data-inside]').scrollLeft = 0;
      }

      // Older iPads/iPhones (Safari 13 and below) have no element.scrollTo(options): fall back safely
      sx(el, left, smooth) {
        if (!el) return;
        try { el.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { el.scrollLeft = left; }
      }

      esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

      select(i, first) {
        var self = this, b = this.data[i];
        if (!b) return;
        this.current = i;
        this.querySelector('[data-atc-sticky]').textContent = 'Get the launch offer';
        this.querySelectorAll('[data-atc-more]').forEach(function (bt) { bt.textContent = 'Get the launch offer · ' + b.price; });
        this.ctaPrice(b);
        var pImg = this.querySelector('[data-picked-img]'), pName = this.querySelector('[data-picked-name]');
        if (pImg && b.chip) pImg.src = b.chip;
        if (pName) pName.textContent = b.short || b.name;
        this.setUsps(b, first);
        this.chips.forEach(function (c, k) { c.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        if (!first || this.track.hasAttribute('data-start') || this.track.children.length !== b.images.length) {
          this.track.removeAttribute('data-start');
          this.track.innerHTML = b.images.map(function (m, k) {
            return '<div class="lp-gallery__slide"><img src="' + self.esc(m.src) + '" alt="' + self.esc(m.alt) + '" width="1080" height="1080"' + (k ? ' loading="lazy"' : '') + '></div>';
          }).join('');
          this.thumbsEl.innerHTML = b.images.map(function (m, k) {
            return '<button type="button" class="lp-thumb" data-thumb="' + k + '" aria-label="Show image ' + (k + 1) + '"' + (k === 0 ? ' aria-current="true"' : '') + '><img src="' + self.esc(m.thumb) + '" alt="" loading="lazy"></button>';
          }).join('');
          this.track.scrollLeft = 0;
        }
        this.mark(0);

        this.querySelector('[data-price]').textContent = b.price;
        this.querySelector('[data-total]').textContent = b.hasSaving ? b.total : '';
        this.querySelector('[data-badge]').textContent = b.hasSaving ? 'SAVE ' + b.percent + '%' : '';
        this.querySelector('[data-atc-label]').textContent = b.available ? 'Get the launch offer · ' + b.price : 'Sold out';
        this.querySelector('[data-atc]').disabled = !b.available;
        this.querySelector('[data-sticky-name]').textContent = (b.short || b.name) + ' guides';
        this.querySelector('[data-sticky-price]').textContent = b.price;
        var stT = this.querySelector('[data-sticky-total]'); if (stT) stT.textContent = b.hasSaving ? b.total : '';
        this.querySelector('[data-inside-h]').textContent = "What's included for your " + (b.short || b.name);
        if (!b.guides || !b.guides.length) { this.genericInside(); } else
        this.querySelector('[data-inside]').innerHTML = b.guides.map(function (g) {
          return '<li><img src="' + self.esc(g.img) + '" alt="' + self.esc(g.title) + ' cover" loading="lazy" width="240" height="360"><b>' + self.esc(g.title) + '</b><em class="' + (g.kind === 'Bonus' ? '' : 'is-main') + '">' + (g.kind === 'Bonus' ? 'Bonus' : 'Main') + '</em></li>';
        }).join('');
        this.querySelector('[data-inside]').scrollLeft = 0;
        // Breed benefit rows
        var rows = (b.rows || []).filter(function (r) { return r.title; });
        var rowHtml = function (list) {
          return list.map(function (r) {
            return '<div class="lp-row">' + (r.img ? '<div class="lp-row__img"><img src="' + self.esc(r.img) + '" alt="' + self.esc(r.title) + '" loading="lazy" width="900" height="675"></div>' : '') + '<div><h3>' + self.esc(r.title) + '</h3><p>' + self.esc(r.text) + '</p></div></div>';
          }).join('');
        };
        [['a', rows]].forEach(function (part) {
          var blk = self.querySelector('[data-rows-block="' + part[0] + '"]');
          if (!blk) return;
          blk.hidden = !part[1].length;
          self.querySelector('[data-rows="' + part[0] + '"]').innerHTML = rowHtml(part[1]);
        });
        this.querySelector('[data-rows-h]').textContent = 'Life with your ' + b.name + ', made easier';
        // Keep the chosen breed in view in the breed row
        var chip = this.chips[i], row = chip && chip.parentElement;
        if (row && row.scrollWidth > row.clientWidth) {
          this.sx(row, Math.max(0, chip.offsetLeft - (row.clientWidth - chip.offsetWidth) / 2), !first);
        }
        if (!first) {
          try { history.replaceState(null, '', (function () { var u = new URL(window.location.href); u.searchParams.set('breed', b.slug); return u.toString(); })()); } catch (e) {}
        }
      }

      mark(i) {
        this.slide = i;
        var n = this.track.children.length;
        if (this.count) this.count.textContent = (i + 1) + ' / ' + n;
        var thumbs = Array.from(this.thumbsEl.children);
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        var act = thumbs[i];
        if (act) this.sx(this.thumbsEl, Math.max(0, act.offsetLeft - (this.thumbsEl.clientWidth - act.offsetWidth) / 2), true);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fireworks"]) return;
  try {
    
  (function () {
    if (!customElements.get('fw-gallery')) {
      customElements.define('fw-gallery', class extends HTMLElement {
        connectedCallback() {
          var self = this;
          var track = this.querySelector('[data-gtrack]');
          var counter = this.querySelector('[data-counter]');
          var slides = this.querySelectorAll('[data-slide]');
          if (!track || slides.length < 2) return;
          var ticking = false;
          track.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              ticking = false;
              var idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
              if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
            });
          }, { passive: true });
          var preload = function () {
            self.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
          };
          if (document.readyState === 'complete') setTimeout(preload, 300);
          else window.addEventListener('load', function () { setTimeout(preload, 300); });
        }
      });
    }

    function money(pence) {
      var v = pence / 100;
      return '£' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
    }

    document.querySelectorAll('[data-fw-form]').forEach(function (form) {
      var mainInput = form.querySelector('[data-main-id]');
      var mainPrice = Number(mainInput.dataset.mainPrice);
      var check = form.querySelector('[data-addon-check]');
      var select = form.querySelector('[data-addon-select]');
      var note = form.querySelector('[data-addon-note]');
      var btn = form.querySelector('[data-fw-btn]');
      var label = form.querySelector('[data-btn-label]');
      var error = form.querySelector('[data-fw-error]');
      var baseLabel = label.textContent.split(' · ')[0];

      function chosen() {
        if (!check || !select || !check.checked || !select.value) return null;
        return select.options[select.selectedIndex];
      }
      function update() {
        var opt = chosen();
        if (opt) {
          var price = Number(opt.dataset.price);
          var total = Number(opt.dataset.total);
          label.textContent = 'Get both · ' + money(mainPrice + price);
          note.hidden = false;
          note.textContent = 'Adding the Complete ' + opt.dataset.name + ' Collection: 7 guides for ' + money(price) + (total > price ? ' (' + money(total) + ' if bought separately)' : '') + '.';
        } else {
          label.textContent = baseLabel + ' · ' + money(mainPrice);
          if (note) note.hidden = true;
        }
      }
      if (select) select.addEventListener('change', function () { if (select.value && check) check.checked = true; update(); });
      if (check) check.addEventListener('change', function () { if (check.checked && select && !select.value) select.focus(); update(); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (check && check.checked && select && !select.value) {
          select.focus();
          note.hidden = false;
          note.textContent = 'Please choose your breed, or untick the box to buy the guide on its own.';
          return;
        }
        var items = [{ id: Number(mainInput.value), quantity: 1 }];
        var opt = chosen();
        if (opt) items.push({ id: Number(opt.value), quantity: 1 });
        btn.disabled = true;
        error.hidden = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () {
          btn.disabled = false;
          error.hidden = false;
        });
      });
      update();
    });

    var sticky = document.querySelector('[data-fw-sticky]');
    var formEl = document.getElementById('fw-form');
    if (sticky && formEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.hidden = e.isIntersecting;
      }).observe(formEl.querySelector('[data-fw-btn]') || formEl);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing"]) return;
  try {
    
  (function () {
    if (customElements.get('lp-page')) return;
    customElements.define('lp-page', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        try { this.data = JSON.parse(this.querySelector('[data-lp-data]').textContent); } catch (e) { this.data = []; }
        if (!this.data.length) return;
        this.track = this.querySelector('[data-track]');
        this.thumbsEl = this.querySelector('[data-thumbs]');
        this.count = this.querySelector('[data-count]');
        this.chips = Array.from(this.querySelectorAll('[data-breed]'));
        this.slide = 0;
        var params = new URLSearchParams(window.location.search);

        // Breed (preselect from ?breed=)
        var want = (params.get('breed') || '').toLowerCase();
        var start = 0;
        if (want) this.data.forEach(function (b, i) { if (b.slug === want || b.handle === want || b.slug.indexOf(want) === 0) start = i; });
        this.chips.forEach(function (c) { c.addEventListener('click', function () { self.select(Number(c.dataset.breed)); }); });
        this.select(start, true);

        // Gallery
        this.track.addEventListener('scroll', function () {
          if (self.ticking) return;
          self.ticking = true;
          requestAnimationFrame(function () {
            self.ticking = false;
            var i = Math.round(self.track.scrollLeft / (self.track.clientWidth || 1));
            if (i !== self.slide) self.mark(i);
          });
        }, { passive: true });
        this.track.addEventListener('click', function () {
          var n = self.track.children.length;
          if (n < 2) return;
          var i = (self.slide + 1) % n;
          self.track.scrollTo({ left: i * self.track.clientWidth });
          self.mark(i);
        });
        this.thumbsEl.addEventListener('click', function (e) {
          var t = e.target.closest('[data-thumb]');
          if (!t) return;
          var i = Number(t.dataset.thumb);
          self.track.scrollTo({ left: i * self.track.clientWidth });
          self.mark(i);
        });

        // Basket
        var atc = function (btn) {
          var b = self.data[self.current];
          if (!b || !b.available) return;
          btn.disabled = true;
          var oldTxt = btn.textContent;
          btn.textContent = 'Adding to basket…';
          self.querySelector('[data-error]').hidden = true;
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: b.variant, quantity: 1 }] }) })
            .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/cart'; })
            .catch(function () { btn.disabled = false; btn.textContent = oldTxt; self.querySelector('[data-error]').hidden = false; });
        };
        var mainBtn = this.querySelector('[data-atc]');
        mainBtn.addEventListener('click', function () { atc(mainBtn); });
        var stickyBtn = this.querySelector('[data-atc-sticky]');
        stickyBtn.addEventListener('click', function () { atc(stickyBtn); });
        var top = this.querySelector('[data-scrolltop]');
        if (top) top.addEventListener('click', function (e) { e.preventDefault(); self.querySelector('.lp-breeds').scrollIntoView({ behavior: 'smooth', block: 'center' }); });

        // Reviews carousel dots
        var rv = this.querySelector('[data-reviews]'), dots = this.querySelector('[data-dots]');
        if (rv && dots) {
          rv.addEventListener('scroll', function () {
            var cards = rv.children, w = cards[0] ? cards[0].offsetWidth + 12 : 1;
            var i = Math.min(dots.children.length - 1, Math.round(rv.scrollLeft / w));
            Array.from(dots.children).forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
          }, { passive: true });
        }

        // Sticky bar: shows whenever the main button is off screen
        var sticky = this.querySelector('[data-sticky]');
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) { sticky.hidden = entries[0].isIntersecting; }).observe(mainBtn);
        }
      }

      esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

      select(i, first) {
        var self = this, b = this.data[i];
        if (!b) return;
        this.current = i;
        this.chips.forEach(function (c, k) { c.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        if (!first || this.track.children.length !== b.images.length) {
          this.track.innerHTML = b.images.map(function (m, k) {
            return '<div class="lp-gallery__slide"><img src="' + self.esc(m.src) + '" alt="' + self.esc(m.alt) + '" width="1080" height="1080"' + (k ? ' loading="lazy"' : '') + '></div>';
          }).join('');
          this.thumbsEl.innerHTML = b.images.map(function (m, k) {
            return '<button type="button" class="lp-thumb" data-thumb="' + k + '" aria-label="Show image ' + (k + 1) + '"' + (k === 0 ? ' aria-current="true"' : '') + '><img src="' + self.esc(m.thumb) + '" alt="" loading="lazy"></button>';
          }).join('');
          this.track.scrollLeft = 0;
        }
        this.mark(0);

        this.querySelector('[data-price]').textContent = b.price;
        this.querySelector('[data-total]').textContent = b.hasSaving ? b.total : '';
        this.querySelector('[data-badge]').textContent = b.hasSaving ? 'SAVE ' + b.percent + '%' : '';
        this.querySelector('[data-atc-label]').textContent = b.available ? 'Get the ' + b.name + ' guides · ' + b.price : 'Sold out';
        this.querySelector('[data-atc]').disabled = !b.available;
        this.querySelector('[data-sticky-name]').textContent = b.name + ' guides';
        this.querySelector('[data-sticky-price]').textContent = b.price;
        this.querySelector('[data-inside-h]').textContent = "What's inside the " + b.name + ' collection';
        this.querySelector('[data-inside]').innerHTML = b.guides.map(function (g) {
          return '<li><img src="' + self.esc(g.img) + '" alt="" loading="lazy" width="56" height="84"><div><b>' + self.esc(g.title) + '</b><p>' + self.esc(g.text) + '</p></div><em class="' + (g.kind === 'Bonus' ? '' : 'is-main') + '">' + (g.kind === 'Bonus' ? 'Bonus' : 'Main') + '</em></li>';
        }).join('');
        // Breed benefit rows
        var rb = this.querySelector('[data-rows-block]');
        var rows = (b.rows || []).filter(function (r) { return r.title; });
        rb.hidden = !rows.length;
        this.querySelector('[data-rows-h]').textContent = 'Life with your ' + b.name + ', made easier';
        this.querySelector('[data-rows]').innerHTML = rows.map(function (r) {
          return '<div class="lp-row">' + (r.img ? '<div class="lp-row__img"><img src="' + self.esc(r.img) + '" alt="' + self.esc(r.title) + '" loading="lazy" width="900" height="675"></div>' : '') + '<div><h3>' + self.esc(r.title) + '</h3><p>' + self.esc(r.text) + '</p></div></div>';
        }).join('');
        // What this breed's collection includes (same for every visitor)
        var cov = this.querySelector('[data-covered]');
        var bonus = b.guides.filter(function (g) { return g.kind === 'Bonus'; });
        var special = bonus.filter(function (g) { return !/(Pulling Fix|Barking Fix|Toilet Habits Fix)$/i.test(g.title); }).slice(0, 2);
        if (b.guides.length) {
          var extra = special.length
            ? ', including ' + special.map(function (g) { return '<b>' + self.esc(g.title) + '</b>'; }).join(' and ')
            : ' for pulling, barking and toilet habits';
          cov.innerHTML = 'Your ' + this.esc(b.name) + ' collection: the Puppy and Adult guides plus ' + bonus.length + ' bonus guides' + extra + '.';
          cov.hidden = false;
        } else {
          cov.hidden = true;
        }
        // Keep the chosen breed in view in the breed row
        var chip = this.chips[i], row = chip && chip.parentElement;
        if (row && row.scrollWidth > row.clientWidth) {
          row.scrollTo({ left: Math.max(0, chip.offsetLeft - (row.clientWidth - chip.offsetWidth) / 2), behavior: first ? 'auto' : 'smooth' });
        }
        if (!first) {
          try { history.replaceState(null, '', (function () { var u = new URL(window.location.href); u.searchParams.set('breed', b.slug); return u.toString(); })()); } catch (e) {}
        }
      }

      mark(i) {
        this.slide = i;
        var n = this.track.children.length;
        if (this.count) this.count.textContent = (i + 1) + ' / ' + n;
        var thumbs = Array.from(this.thumbsEl.children);
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        var act = thumbs[i];
        if (act) this.thumbsEl.scrollTo({ left: Math.max(0, act.offsetLeft - (this.thumbsEl.clientWidth - act.offsetWidth) / 2), behavior: 'smooth' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp"]) return;
  try {
    
  (function () {
    if (!customElements.get('bt-gallery')) {
      customElements.define('bt-gallery', class extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.track = this.querySelector('[data-gtrack]');
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
          this.counter = this.querySelector('[data-counter]');
          this.index = 0;
          if (!this.track || this.slides.length < 2) return;
          var prev = this.querySelector('[data-prev]');
          var next = this.querySelector('[data-next]');
          if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
          if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
          this.thumbs.forEach(function (t) { t.addEventListener('click', function () { self.go(Number(t.dataset.thumb)); }); });
          var ticking = false;
          this.track.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              ticking = false;
              var w = self.track.clientWidth || 1;
              var idx = Math.round(self.track.scrollLeft / w);
              if (idx !== self.index) self.mark(idx);
            });
          }, { passive: true });
          var preload = function () {
            self.slides.forEach(function (s) {
              var img = s.querySelector('img[loading="lazy"]');
              if (img) img.loading = 'eager';
            });
          };
          if (document.readyState === 'complete') setTimeout(preload, 300);
          else window.addEventListener('load', function () { setTimeout(preload, 300); });
          this.track.addEventListener('touchstart', preload, { once: true, passive: true });
        }
        go(n) {
          var len = this.slides.length;
          var idx = (n + len) % len;
          this.track.scrollTo({ left: idx * this.track.clientWidth });
          this.mark(idx);
        }
        mark(idx) {
          var len = this.slides.length;
          this.index = idx;
          this.thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
          var active = this.thumbs[idx];
          if (active && active.parentElement) {
            var row = active.parentElement;
            var left = active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2;
            row.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
          if (this.counter) this.counter.textContent = (idx + 1) + ' / ' + len;
        }
      });
    }

    if (!customElements.get('bt-carousel')) {
      // Shared reviews: one at a time, box fits the review on show, arrows + dots
      if (!customElements.get('bt-rv')) customElements.define('bt-rv', class extends HTMLElement {
        connectedCallback() {
          var self = this, tr = this.querySelector('[data-track]'), dots = this.querySelector('[data-dots]');
          if (!tr || !tr.children.length) return;
          var idx = 0, tick = false;
          var sx = function (left) { try { tr.scrollTo({ left: left, behavior: 'smooth' }); } catch (e) { tr.scrollLeft = left; } };
          var fit = function () { var c = tr.children[idx]; if (c) tr.style.height = c.offsetHeight + 'px'; };
          var mark = function (i) { idx = i; if (dots) Array.from(dots.children).forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); fit(); };
          var go = function (i) { var n = tr.children.length; i = (i + n) % n; sx(tr.children[i].offsetLeft - tr.children[0].offsetLeft); mark(i); };
          tr.addEventListener('scroll', function () {
            if (tick) return; tick = true;
            requestAnimationFrame(function () { tick = false; var i = Math.round(tr.scrollLeft / (tr.clientWidth || 1)); if (i !== idx && tr.children[i]) mark(i); });
          }, { passive: true });
          var pv = this.querySelector('[data-prev]'), nx = this.querySelector('[data-next]');
          if (pv) pv.addEventListener('click', function () { go(idx - 1); });
          if (nx) nx.addEventListener('click', function () { go(idx + 1); });
          if (dots) Array.from(dots.children).forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
          fit();
          window.addEventListener('resize', fit);
          window.addEventListener('load', fit);
          if ('ResizeObserver' in window) { var ro = new ResizeObserver(fit); Array.from(tr.children).forEach(function (c) { ro.observe(c); }); }
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
        }
      });

      customElements.define('bt-carousel', class extends HTMLElement {
        connectedCallback() {
          var track = this.querySelector('[data-track]');
          if (!track) return;
          var step = function () {
            var card = track.firstElementChild;
            if (!card) return 300;
            var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
            return card.getBoundingClientRect().width + gap;
          };
          var prev = this.querySelector('[data-prev]');
          var next = this.querySelector('[data-next]');
          if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
          if (next) next.addEventListener('click', function () {
            var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
            if (atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
            else track.scrollBy({ left: step(), behavior: 'smooth' });
          });
        }
      });
    }

    if (!customElements.get('bt-sticky-atc')) {
      customElements.define('bt-sticky-atc', class extends HTMLElement {
        connectedCallback() {
          var self = this;
          var target = document.querySelector(this.dataset.target);
          var button = this.querySelector('button');
          if (!target || !('IntersectionObserver' in window)) return;
          new IntersectionObserver(function (entries) {
            var entry = entries[0];
            var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            self.classList.toggle('is-visible', show);
            self.setAttribute('aria-hidden', show ? 'false' : 'true');
            if (button) button.tabIndex = show ? 0 : -1;
          }).observe(target);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
